import React, { useState, useEffect } from 'react';
import { apiCall } from '../utils/api';
import './Dashboard.css';

const AdminCommunityManagement = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    senderName: 'Admin',
    role: 'admin',
    message: '',
  });

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const data = await apiCall('/community-chat');
      setMessages(data);
    } catch (error) {
      console.error('Error fetching messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.message.trim()) return;

    try {
      if (editingId) {
        await apiCall(`/community-chat/${editingId}`, 'PUT', formData);
        alert('✅ Message updated successfully!');
      } else {
        await apiCall('/community-chat', 'POST', formData);
        alert('✅ Admin card created successfully!');
      }
      setFormData({ ...formData, message: '' });
      setEditingId(null);
      fetchMessages();
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  const handleEdit = (msg) => {
    setEditingId(msg._id);
    setFormData({
      senderName: msg.senderName,
      role: msg.role,
      message: msg.message,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      try {
        await apiCall(`/community-chat/${id}`, 'DELETE');
        fetchMessages();
      } catch (error) {
        alert('Error: ' + error.message);
      }
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-community-mgmt">
      <section className="dashboard-section">
        <div className="section-header">
          <h2>Community Chat Management</h2>
        </div>

        {/* Create/Edit Form */}
        <div className="form-card card" style={{ marginBottom: '30px' }}>
          <div className="card-header">
            <h3>{editingId ? 'Edit Message' : 'Create Admin Card'}</h3>
          </div>
          <div className="card-content">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Sender Name</label>
                  <input
                    type="text"
                    value={formData.senderName}
                    onChange={(e) => setFormData({ ...formData, senderName: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Role</label>
                  <select
                    value={formData.role}
                    onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                  >
                    <option value="admin">Admin</option>
                    <option value="teacher">Teacher</option>
                    <option value="user">User</option>
                  </select>
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                  <label>Message / Card Content</label>
                  <textarea
                    rows="3"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    placeholder="Enter what will appear on the card..."
                    required
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                  ></textarea>
                </div>
              </div>
              <div className="form-actions" style={{ marginTop: '15px' }}>
                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Update Message' : 'Post Card'}
                </button>
                {editingId && (
                  <button type="button" onClick={() => { setEditingId(null); setFormData({ ...formData, message: '' }); }} className="btn btn-secondary">
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>

        {/* Messages List */}
        <div className="table-container card">
          <div className="card-header">
            <h3>Recent Messages</h3>
          </div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Sender</th>
                <th>Role</th>
                <th>Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((msg) => (
                <tr key={msg._id}>
                  <td>{new Date(msg.createdAt).toLocaleDateString()}</td>
                  <td><strong>{msg.senderName}</strong></td>
                  <td>
                    <span className={`badge badge-${msg.role === 'admin' ? 'success' : (msg.role === 'teacher' ? 'primary' : 'warning')}`}>
                      {msg.role}
                    </span>
                  </td>
                  <td style={{ maxWidth: '300px', whiteSpace: 'normal' }}>{msg.message}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button onClick={() => handleEdit(msg)} className="btn btn-sm btn-info" style={{ padding: '4px 10px', fontSize: '12px' }}>Edit</button>
                      <button onClick={() => handleDelete(msg._id)} className="btn btn-sm btn-danger" style={{ padding: '4px 10px', fontSize: '12px' }}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default AdminCommunityManagement;
